// @todo Remove when we do not need to fallback to norwegian.
export const fallbackLocale = 'nb';
